export function customersTabs() {
    let section = $(".our-customers");
    let navItems = section.find(".tab-nav li");
    let navigationItems = section.find(".tab-nav a");
    let pages = section.find(".customer-page");

    navItems.eq(0).addClass("active");
    pages.eq(0).addClass("active visible");


    navigationItems.each((i, item) => {

        let parent = $(item).parent("li");
        let id = $(item).attr("href");

        $(item).on("click", function (e) {
            e.preventDefault();

            if(!parent.hasClass("active")) {
                navItems.removeClass("active");
                pages.removeClass("active visible");

                parent.add($(id)).addClass("active");

                setTimeout(function () {
                    $(id).addClass("visible");
                }, 100);
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/our-customers-tabs.js